// Generated by purs version 0.11.7
"use strict";
var Data_Lens_Lens = require("../Data.Lens.Lens");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong");
var Data_Tuple = require("../Data.Tuple");
var _2 = function (dictStrong) {
    return Data_Profunctor_Strong.second(dictStrong);
};
var _1 = function (dictStrong) {
    return Data_Profunctor_Strong.first(dictStrong);
};
module.exports = {
    _1: _1,
    _2: _2
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Lens.Lens.Tuple/index.js
// module id = 549
// module chunks = 0